import styled from 'styled-components';

export const Link = styled.a`
  cursor: pointer;
  color: #005cde;
  text-align: center;
  font-weight: bold;
  font-size: 14px;
`;
